import { ILanguageSwitcherLanguage } from '@hg/stylizator/components'

interface IConfigLanguage {
  code: string
  name: string
  active: boolean
  url: string
}

export const parseConfigLanguage = (config: Record<string, IConfigLanguage>): ILanguageSwitcherLanguage[] => {
  return Object.values(config).map((item) => ({
    abbreviation: item.code.toUpperCase(),
    label: `${item.name[0].toUpperCase()}${item.name.slice(1)}`,
    isSelected: item.active,
    onClick: (): void => {
      window.location.href = item.url
    },
  }))
}
